import CRUDService from './CRUDService';
import {UserConnection} from 'src/types/userConnections';

export default new CRUDService<UserConnection>('/v1/user-connections');
